import React from 'react';
import { useProgress } from 'components/layout_and_quote_builder/utils/ProgressContext.jsx';
import styles from 'components/frank/_style.module.scss';

// The listing's progress while it scores its manufacturing lines, IN PLACE: a hairline rail above the cards
// rather than a full-screen card over them.
//
// The cards it sits above are already complete -- machines, beds and badges all arrive with the listing's first
// request, and only each card's SCORE is still in flight. Covering them with ProgressBarOverlay hid content
// that was already on screen, so this replaces it. (That overlay is shared with the legacy page and stays
// exactly as it is; Frank just stops rendering it.)
//
// DETERMINATE, honestly: the listing scores one line per request through the shared queue, so completed/total
// is a real fraction rather than an invented one.
const ListingProgressBar = () => {
  const { progress } = useProgress();

  // Nothing queued, or everything already answered -- the cards carry their own scores now.
  if (progress.total === 0 || progress.completed === progress.total) {
    return null;
  }

  return (
    <div data-frank-listing-progress={progress.percentage}>
      <div className={styles.listingProgressLabel}>
        {t('quote_builder.listing_scoring_manufacturing_lines')}
      </div>
      <div
        className={styles.listingProgress}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={progress.total}
        aria-valuenow={progress.completed}
        aria-label={t('quote_builder.listing_scoring_manufacturing_lines')}
      >
        <div className={styles.listingProgressFill} style={{ width: `${progress.percentage}%` }} />
      </div>
    </div>
  );
};

export default ListingProgressBar;
